module.exports = __webpack_public_path__ + "img/yuyingshanfang.46181468.png";